import{ FiArrowRight } from 'react-icons/fi'

export const Friends = () => {
    return (
        <div className="user__followers mb-3">
              <div className="user__followers">
                    <div className="user__follower__header">
                        <div>
                            <h3 className="big_title big">Friends</h3>
                            <p className="desc">11,725,858</p>
                        </div>
                        <div className="arrow_icon">
                            <FiArrowRight size={19} />
                        </div>
                    </div>
                    <div className="user__follower">
                        <div> <img src="/assets/images/faces/1.png" alt="" /></div>
                        <div> <img src="/assets/images/faces/2.png" alt="" /></div>
                        <div> <img src="/assets/images/faces/3.png" alt="" /></div>
                        <div> <img src="/assets/images/faces/4.png" alt="" /></div>
                        <div> <img src="/assets/images/faces/5.png" alt="" /></div>
                        <div> <img src="/assets/images/faces/6.png" alt="" /></div>
                        <div> <img src="/assets/images/faces/7.png" alt="" /></div>
                        <div> <img src="/assets/images/faces/8.png" alt="" /></div>
                        <div> <img src="/assets/images/faces/9.png" alt="" /></div>
                    </div>
                </div>
        </div>
    )
}